var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRightOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.468 4.26a.9.9 0 0 0-.089 1.18l.08.092L17.95 11.1H3.9a.9.9 0 0 0-.113 1.793l.113.007h14.05l-5.49 5.568a.9.9 0 0 0-.073 1.181l.081.092a.9.9 0 0 0 1.181.072l.092-.081 7-7.1a.9.9 0 0 0 .08-1.172l-.08-.092-7-7.1a.9.9 0 0 0-1.273-.009Z"
})));
export { SvgArrowRightOutline24 as ReactComponent };